import { useMutation } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

export type MultiCheckoutLinkItem = {
  productId: string;
  productVariantId?: string;
  quantity: number;
};

type CreateMultiCheckoutLinkInput = {
  storeSlug: string;
  items: MultiCheckoutLinkItem[];
};

type CreateCheckoutLinkResponse = {
  url: string;
  token: string;
  expiresAt: string;
};

export function useCreateMultiCheckoutLinkMutation() {
  const mutation = useMutation({
    mutationFn: (input: CreateMultiCheckoutLinkInput) => {
      const { storeSlug, ...body } = input;
      return apiJsonClient<CreateCheckoutLinkResponse>(
        endpoints.seller.checkoutLinks(storeSlug),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      );
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
